import { useCallback, useEffect, useState } from "react";
import { getLabTodayDateOnly, type DateOnlyString } from "../utils/dateOnly";

const LAB_DAY_REFRESH_INTERVAL_MS = 30_000;

export function useLabTodayDateOnly(): DateOnlyString {
  const [labToday, setLabToday] = useState(() => getLabTodayDateOnly());

  const refreshLabToday = useCallback(() => {
    const nextLabToday = getLabTodayDateOnly();
    setLabToday((currentLabToday) =>
      currentLabToday === nextLabToday ? currentLabToday : nextLabToday
    );
  }, []);

  useEffect(() => {
    const intervalId = window.setInterval(
      refreshLabToday,
      LAB_DAY_REFRESH_INTERVAL_MS
    );
    return () => window.clearInterval(intervalId);
  }, [refreshLabToday]);

  return labToday;
}
